/* Initial Nonsense Words audio */

import generalInstruction from '../sounds/bp_nw_general_instruction.mp3';
import practiceClickInstruction from '../sounds/bp_nw_practice_click_instruction.mp3';
import practiceAnswerInstruction from '../sounds/bp_nw_practice_answer_instruction.mp3';

const NONSENSE_WORD_AUDIO_INSTRUCTIONS = {
    generalInstruction,
    practiceClickInstruction,
    practiceAnswerInstruction,
};

export default NONSENSE_WORD_AUDIO_INSTRUCTIONS;
